import React from "react";
import styles from "../PanelUser/PanelLayout.module.css";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosConfig";

function getInitials(name = "", lastName = "") {
  return `${name[0] || ""}${lastName[0] || ""}`.toUpperCase() || "?";
}

const menuItems = [
  { label: "Resumen", path: "/administrar" },
  { label: "Profesionales", path: "/administrar/profesionales" },
  { label: "Sedes", path: "/administrar/sedes" },
  { label: "Empresas", path: "/administrar/empresas" },
  { label: "Usuarios", path: "/administrar/usuarios" },
  { label: "Configuración", path: "/administrar/configuracion" },
];

function PanelAdmin(props) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = React.useState(null);
  const [token, setToken] = React.useState("");

  React.useEffect(() => {
    const t = localStorage.getItem("token");
    setToken(t || "");
  }, []);

  React.useEffect(() => {
    if (!token) return;
    axiosInstance
      .get("/api/datapersonal", { headers: { Authorization: token } })
      .then((r) => setUser(r.data))
      .catch(console.error);
  }, [token]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const initials = user ? getInitials(user.name, user.lastName || "") : "AD";

  return (
    <div className={styles.panelPage}>
      {/* SIDEBAR */}
      <aside className={styles.sidebar}>
        <div>
          <div className={styles.sidebarTop}>
            {user?.image ? (
              <img src={user.image} alt="avatar" className={styles.avatarImg} />
            ) : (
              <div className={styles.avatar}>{initials}</div>
            )}
            <p className={styles.userName}>{user?.name} {user?.lastName}</p>
            <p className={styles.userEmail}>{user?.email}</p>
          </div>
          <p className={styles.menuLabel}>Menú principal</p>
          <ul className={styles.menuList}>
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`${styles.menuItem} ${pathname === item.path ? styles.menuItemActive : ""}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.sidebarBottom}>
          <button className={styles.btnLogout} onClick={handleLogout}>
            Cerrar sesión
          </button>
        </div>
      </aside>

      {/* MAIN */}
      <main className={styles.main}>
        <div className={styles.mainHeader}>
          <div className={styles.mainHeaderLeft}>
            <p>Administrar</p>
            <h1>{menuItems.find((m) => m.path === pathname)?.label || "Panel"}</h1>
          </div>
        </div>
        <Outlet />
      </main>
    </div>
  );
}

export default PanelAdmin;
